import { useMutation } from "@tanstack/react-query";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-hot-toast";
import { handleForgotPassword } from "../../api/forgotpassword";
import useAuth from "../../hooks/auth/useAuth";
import bgAbstract from "../../assets/loginPattern.svg";
import { Button, Input } from "../../components/ui";
import { useForm } from "react-hook-form";
import { COMPANY_NAME } from "../../config";
import logo from "../../assets/images/newlogo.webp";

const ForgotPassword = () => {
  const { control, handleSubmit } = useForm({
    defaultValues: {
      email: "",
    },
  });

  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const { mutate, isLoading } = useMutation(handleForgotPassword, {
    onSuccess: (response) => {
      if (response.status === 200) {
        toast.success("Email sent successfully!", {
          position: "top-right",
          duration: 3000,
        });
        navigate("/login");
      }
    },
    onError: (err) => {
      if (err.response?.status === 400) {
        toast.error(err.response?.data?.message, {
          position: "top-right",
          duration: 3000,
        });
      }
    },
  });

  const onSubmit = (data) => {
    mutate(data);
  };

  return (
    <div className="h-screen bg-bodyBackground flex flex-col lg:flex-row overflow-hidden fixed w-full">
      <div
        className="w-full lg:block hidden lg:w-[60%] h-[60%] lg:h-full loginPage-bgImage relative"
        style={{ backgroundImage: `url(${bgAbstract})` }}
      >
        <div className=" p-10 lg:p-16 h-full flex flex-col justify-between">
          <div className="w-[280px] flex flex-col overflow-hidden text-end">
            <h1 className=" text-white text-2xl lg:text-5xl font-bold drop-shadow-md tracking-wider font-roboto">
              OfficeMate
            </h1>
            <p className="text-white ">By iDigitize</p>
          </div>
          <div>
            <div className=" mt-10 lg:mt-0 mb-6 lg:mb-24">
              <h3 className=" drop-shadow-md text-white text-base lg:text-4xl mb-4 font-semibold">
                Streamline HR Operations
              </h3>
              <p className=" text-white drop-shadow-md text-base lg:text-lg">
                Unlock the Potential of Your Workforce. Discover a Dynamic Hub
                Where Data Flourishes. Our HRMS Platform is the Gateway to a
                More Efficient, Connected, and Innovative Workplace.
              </p>
            </div>
            <div className=" space-x-6">
              <a
                href="http://"
                target="_blank"
                rel="noopener noreferrer"
                className=" text-sm lg:text-base text-white drop-shadow-md hover:underline"
              >
                Privacy Policy
              </a>
              <span className="text-white drop-shadow-md text-sm lg:text-base">
                @ 2025, iDigitize I All Rights Reserved I Designed, Developed &
                Managed By iDigitize Infotech LLP
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full  lg:w-[40%] h-full lg:h-full flex flex-col items-center justify-center">
        <img
          src={logo}
          alt="iDom Logo"
          className="w-auto h-16 mb-5"
        />
        <div className="flex flex-col items-center justify-center w-full">
          <p className="text-3xl font-semibold text-primary mb-4">
            Forgot Password
          </p>
          <form
            className="space-y-4 w-[80%] mx-auto"
            autoComplete="on"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div>
              <label htmlFor="email" className="flex text-xl">
                Email
              </label>
              <Input
                className=""
                control={control}
                name="email"
                placeholder="Enter your email here"
              />
            </div>

            <div className="w-full flex justify-end">
              <a className="underline font-medium" href="/login">
                Back to Login page
              </a>
            </div>

            {isLoading ? (
              <div className="bg-primary w-full rounded-md py-2 text-white flex items-center justify-center">
                <svg
                  className="w-5 h-5 animate-spin text-white"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
                  ></path>
                </svg>
              </div>
            ) : (
              <Button type="submit">Send Email</Button>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
